var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { Map, List, fromJS } from 'immutable';
import { Group, Layer, Hole, Vertex } from
//Area
'./export';
import { IDBroker, NameGenerator, GeometryUtils, SnapUtils, SnapSceneUtils } from '../utils/export';
import { MODE_IDLE, MODE_WAITING_DRAWING_PIPE, MODE_DRAWING_PIPE, MODE_DRAGGING_PIPE } from '../constants';
import { CatalogElement } from '../models';

var Pipe = function () {
  function Pipe() {
    _classCallCheck(this, Pipe);
  }

  _createClass(Pipe, null, [{
    key: 'create',
    value: function create(state, layerID, type, x0, y0, x1, y1, properties) {

      var pipeID = IDBroker.acquireID();

      var _Vertex$add = Vertex.add(state, layerID, x0, y0, 'pipes', pipeID, true),
          stateV0 = _Vertex$add.updatedState,
          v0 = _Vertex$add.vertex;

      var _Vertex$add2 = Vertex.add(stateV0, layerID, x1, y1, 'pipes', pipeID, true),
          stateV1 = _Vertex$add2.updatedState,
          v1 = _Vertex$add2.vertex;

      state = stateV1;

      var pipe = state.catalog.factoryElement(type, {
        id: pipeID,
        name: NameGenerator.generateName('pipes', state.catalog.getIn(['elements', type, 'info', 'title'])),
        vertices: new List([v0.id, v1.id]),
        type: type,
        floorID: state.getIn(['scene', 'selectedFloor'])
      }, properties);

      state = state.setIn(['scene', 'layers', layerID, 'pipes', pipeID], pipe);

      return { updatedState: state, pipe: pipe };
    }
  }, {
    key: 'select',
    value: function select(state, layerID, pipeID) {
      state = Layer.select(state, layerID).updatedState;

      var pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);

      state = Layer.selectElement(state, layerID, 'pipes', pipeID).updatedState;
      state = Layer.selectElement(state, layerID, 'vertices', pipe.vertices.get(0)).updatedState;
      state = Layer.selectElement(state, layerID, 'vertices', pipe.vertices.get(1)).updatedState;

      return { updatedState: state };
    }
  }, {
    key: 'remove',
    value: function remove(state, layerID, pipeID) {
      var pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);

      if (pipe) {
        state = this.unselect(state, layerID, pipeID).updatedState;
        pipe.holes.forEach(function (holeID) {
          return state = Hole.remove(state, layerID, holeID).updatedState;
        });
        state = Layer.removeElement(state, layerID, 'pipes', pipeID).updatedState;

        pipe.vertices.forEach(function (vertexID) {
          return state = Vertex.remove(state, layerID, vertexID, 'pipes', pipeID).updatedState;
        });

        state.getIn(['scene', 'groups']).forEach(function (group) {
          return state = Group.removeElement(state, group.id, layerID, 'pipes', pipeID).updatedState;
        });
      }

      return { updatedState: state };
    }
  }, {
    key: 'unselect',
    value: function unselect(state, layerID, pipeID) {
      var pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);

      if (pipe) {
        state = Layer.unselect(state, layerID, 'vertices', pipe.vertices.get(0)).updatedState;
        state = Layer.unselect(state, layerID, 'vertices', pipe.vertices.get(1)).updatedState;
        state = Layer.unselect(state, layerID, 'pipes', pipeID).updatedState;
      }

      return { updatedState: state };
    }
  }, {
    key: 'selectToolDrawingPipe',
    value: function selectToolDrawingPipe(state, sceneComponentType) {
      state = state.merge({
        mode: MODE_WAITING_DRAWING_PIPE,
        drawingSupport: new Map({
          type: sceneComponentType
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'beginDrawingPipe',
    value: function beginDrawingPipe(state, layerID, x, y) {
      var snapElements = SnapSceneUtils.sceneSnapElements(state.scene, new List(), state.snapMask, true);
      var snap = null;

      if (state.snapMask && !state.snapMask.isEmpty()) {
        snap = SnapUtils.nearestSnap(snapElements, x, y, state.snapMask);
        if (snap) {
          ;

          var _snap$point = snap.point;
          x = _snap$point.x;
          y = _snap$point.y;
        }snapElements = snapElements.withMutations(function (snapElements) {
          var a = void 0,
              b = void 0,
              c = void 0;

          var _GeometryUtils$horizo = GeometryUtils.horizontalLine(y);

          a = _GeometryUtils$horizo.a;
          b = _GeometryUtils$horizo.b;
          c = _GeometryUtils$horizo.c;

          SnapUtils.addLineSnap(snapElements, a, b, c, 10, 3, null);

          var _GeometryUtils$vertic = GeometryUtils.verticalLine(x);

          a = _GeometryUtils$vertic.a;
          b = _GeometryUtils$vertic.b;
          c = _GeometryUtils$vertic.c;

          SnapUtils.addLineSnap(snapElements, a, b, c, 10, 3, null);
        });
      }

      var drawingSupport = state.get('drawingSupport').set('layerID', layerID);

      state = Layer.unselectAll(state, layerID).updatedState;

      var _Pipe$create = Pipe.create(state, layerID, drawingSupport.get('type'), x, y, x, y),
          stateL = _Pipe$create.updatedState,
          pipe = _Pipe$create.pipe;

      state = Pipe.select(stateL, layerID, pipe.id).updatedState;

      state = state.merge({
        mode: MODE_DRAWING_PIPE,
        snapElements: snapElements,
        activeSnapElement: snap ? snap.snap : null,
        drawingSupport: drawingSupport
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateDrawingPipe',
    value: function updateDrawingPipe(state, x, y) {
      var snap = null;
      if (state.snapMask && !state.snapMask.isEmpty()) {
        snap = SnapUtils.nearestSnap(state.snapElements, x, y, state.snapMask);
        if (snap) {
          ;
          var _snap$point2 = snap.point;
          x = _snap$point2.x;
          y = _snap$point2.y;
        }
      }

      var layerID = state.getIn(['drawingSupport', 'layerID']);
      var pipeID = state.getIn(['scene', 'layers', layerID, 'selected', 'pipes']).first();

      var _Pipe$replaceVertex = Pipe.replaceVertex(state, layerID, pipeID, 1, x, y),
          stateLV = _Pipe$replaceVertex.updatedState,
          vertex = _Pipe$replaceVertex.vertex;

      state = stateLV;

      state = this.select(state, layerID, pipeID).updatedState;

      state = state.merge({ activeSnapElement: snap ? snap.snap : null });

      return { updatedState: state };
    }
  }, {
    key: 'replaceVertex',
    value: function replaceVertex(state, layerID, pipeID, vertexIndex, x, y) {
      var vertexID = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID, 'vertices', vertexIndex]);

      state = Vertex.remove(state, layerID, vertexID, 'pipes', pipeID).updatedState;

      var _Vertex$add3 = Vertex.add(state, layerID, x, y, 'pipes', pipeID, true),
          stateV = _Vertex$add3.updatedState,
          vertex = _Vertex$add3.vertex;

      state = stateV;

      state = state.setIn(['scene', 'layers', layerID, 'pipes', pipeID, 'vertices', vertexIndex], vertex.id);
      state = state.setIn(['scene', 'layers', layerID, 'pipes', pipeID], state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]));

      return { updatedState: state, pipe: state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]), vertex: vertex };
    }
  }, {
    key: 'endDrawingPipe',
    value: function endDrawingPipe(state, x, y) {

      if (state.snapMask && !state.snapMask.isEmpty()) {
        var snap = SnapUtils.nearestSnap(state.snapElements, x, y, state.snapMask);
        if (snap) {
          ;
          var _snap$point3 = snap.point;
          x = _snap$point3.x;
          y = _snap$point3.y;
        }
      }

      var layerID = state.getIn(['drawingSupport', 'layerID']);
      var pipeID = state.getIn(['scene', 'layers', layerID, 'selected', 'pipes']).first();
      var layer = state.scene.layers.get(layerID);
      var pipe = layer.pipes.get(pipeID);

      state = Pipe.setPipeLengthMisc(state, layerID, pipe.id).updatedState;
      state = Layer.unselectAll(state, layerID).updatedState;
      state = Layer.removeZeroLengthPipes(state, layerID).updatedState;

      state = state.merge({
        mode: MODE_WAITING_DRAWING_PIPE,
        draggingSupport: null,
        activeSnapElement: null,
        snapElements: new List()
      });

      return { updatedState: state };
    }
  }, {
    key: 'beginDraggingPipe',
    value: function beginDraggingPipe(state, layerID, pipeID, x, y) {

      var snapElements = SnapSceneUtils.sceneSnapElements(state.scene, new List(), state.snapMask, true);

      var layer = state.scene.layers.get(layerID);
      var pipe = layer.pipes.get(pipeID);

      var vertex0 = layer.vertices.get(pipe.vertices.get(0));
      var vertex1 = layer.vertices.get(pipe.vertices.get(1));

      state = state.merge({
        mode: MODE_DRAGGING_PIPE,
        snapElements: snapElements,
        draggingSupport: Map({
          layerID: layerID, pipeID: pipeID,
          startPointX: x,
          startPointY: y,
          startVertex0X: vertex0.x,
          startVertex0Y: vertex0.y,
          startVertex1X: vertex1.x,
          startVertex1Y: vertex1.y
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateDraggingPipe',
    value: function updateDraggingPipe(state, x, y) {

      var draggingSupport = state.draggingSupport;
      var snapElements = state.snapElements;

      var layerID = draggingSupport.get('layerID');
      var pipeID = draggingSupport.get('pipeID');
      var diffX = x - draggingSupport.get('startPointX');
      var diffY = y - draggingSupport.get('startPointY');
      var newVertex0X = draggingSupport.get('startVertex0X') + diffX;
      var newVertex0Y = draggingSupport.get('startVertex0Y') + diffY;
      var newVertex1X = draggingSupport.get('startVertex1X') + diffX;
      var newVertex1Y = draggingSupport.get('startVertex1Y') + diffY;

      var activeSnapElement = null;
      var curSnap0 = null,
          curSnap1 = null;
      if (state.snapMask && !state.snapMask.isEmpty()) {
        curSnap0 = SnapUtils.nearestSnap(snapElements, newVertex0X, newVertex0Y, state.snapMask);
        curSnap1 = SnapUtils.nearestSnap(snapElements, newVertex1X, newVertex1Y, state.snapMask);
      }

      var deltaX = 0,
          deltaY = 0;
      if (curSnap0 && curSnap1) {
        if (curSnap0.point.distance < curSnap1.point.distance) {
          deltaX = curSnap0.point.x - newVertex0X;
          deltaY = curSnap0.point.y - newVertex0Y;
          activeSnapElement = curSnap0.snap;
        } else {
          deltaX = curSnap1.point.x - newVertex1X;
          deltaY = curSnap1.point.y - newVertex1Y;
          activeSnapElement = curSnap1.snap;
        }
      } else {
        if (curSnap0) {
          deltaX = curSnap0.point.x - newVertex0X;
          deltaY = curSnap0.point.y - newVertex0Y;
          activeSnapElement = curSnap0.snap;
        }
        if (curSnap1) {
          deltaX = curSnap1.point.x - newVertex1X;
          deltaY = curSnap1.point.y - newVertex1Y;
          activeSnapElement = curSnap1.snap;
        }
      }

      newVertex0X += deltaX;
      newVertex0Y += deltaY;
      newVertex1X += deltaX;
      newVertex1Y += deltaY;

      state = state.merge({
        activeSnapElement: activeSnapElement,
        scene: state.scene.updateIn(['layers', layerID], function (layer) {
          return layer.withMutations(function (layer) {
            var pipeVertices = layer.getIn(['pipes', pipeID, 'vertices']);
            layer.updateIn(['vertices', pipeVertices.get(0)], function (vertex) {
              return vertex.merge({ x: newVertex0X, y: newVertex0Y });
            });
            layer.updateIn(['vertices', pipeVertices.get(1)], function (vertex) {
              return vertex.merge({ x: newVertex1X, y: newVertex1Y });
            });
            return layer;
          });
        })
      });

      return { updatedState: state };
    }
  }, {
    key: 'endDraggingPipe',
    value: function endDraggingPipe(state, x, y) {
      var _state = state,
          draggingSupport = _state.draggingSupport;

      var layerID = draggingSupport.get('layerID');
      var layer = state.scene.layers.get(layerID);
      var pipeID = draggingSupport.get('pipeID');
      var pipe = layer.pipes.get(pipeID);

      var vertex0 = layer.vertices.get(pipe.vertices.get(0));
      var vertex1 = layer.vertices.get(pipe.vertices.get(1));

      var maxV = GeometryUtils.maxVertex(vertex0, vertex1);
      var minV = GeometryUtils.minVertex(vertex0, vertex1);

      var lineLength = GeometryUtils.verticesDistance(minV, maxV);
      var alpha = Math.atan2(maxV.y - minV.y, maxV.x - minV.x);

      var holesWithOffsetPosition = [];
      layer.pipes.get(pipeID).holes.forEach(function (holeID) {
        var hole = layer.holes.get(holeID);
        var pointOnLine = lineLength * hole.offset;

        var offsetPosition = {
          x: pointOnLine * Math.cos(alpha) + minV.x,
          y: pointOnLine * Math.sin(alpha) + minV.y
        };

        holesWithOffsetPosition.push({ hole: hole, offsetPosition: offsetPosition });
      });

      var diffX = x - draggingSupport.get('startPointX');
      var diffY = y - draggingSupport.get('startPointY');
      var newVertex0X = draggingSupport.get('startVertex0X') + diffX;
      var newVertex0Y = draggingSupport.get('startVertex0Y') + diffY;
      var newVertex1X = draggingSupport.get('startVertex1X') + diffX;
      var newVertex1Y = draggingSupport.get('startVertex1Y') + diffY;

      if (state.snapMask && !state.snapMask.isEmpty()) {

        var curSnap0 = SnapUtils.nearestSnap(state.snapElements, newVertex0X, newVertex0Y, state.snapMask);
        var curSnap1 = SnapUtils.nearestSnap(state.snapElements, newVertex1X, newVertex1Y, state.snapMask);

        var deltaX = 0,
            deltaY = 0;
        if (curSnap0 && curSnap1) {
          if (curSnap0.point.distance < curSnap1.point.distance) {
            deltaX = curSnap0.point.x - newVertex0X;
            deltaY = curSnap0.point.y - newVertex0Y;
          } else {
            deltaX = curSnap1.point.x - newVertex1X;
            deltaY = curSnap1.point.y - newVertex1Y;
          }
        } else {
          if (curSnap0) {
            deltaX = curSnap0.point.x - newVertex0X;
            deltaY = curSnap0.point.y - newVertex0Y;
          }
          if (curSnap1) {
            deltaX = curSnap1.point.x - newVertex1X;
            deltaY = curSnap1.point.y - newVertex1Y;
          }
        }

        newVertex0X += deltaX;
        newVertex0Y += deltaY;
        newVertex1X += deltaX;
        newVertex1Y += deltaY;
      }

      var pipeGroups = state //get groups membership if present
      .getIn(['scene', 'groups']).filter(function (group) {
        var pipes = group.getIn(['elements', layerID, 'pipes']);
        return pipes && pipes.contains(pipeID);
      });

      //#region Pipe merging of vertexes on drag and pipe spliting

      // Uncomment this two lines if pipe vertex merging on drag needed
      // state = Layer.mergeEqualsVerticesPipes(state, layerID, pipe.vertices.get(0)).updatedState;
      // state = Layer.mergeEqualsVerticesPipes(state, layerID, pipe.vertices.get(1)).updatedState;

      // Uncommnet this part if pipes splitting on drag needed. Splitting methods in commented region on end of file.
      // state = Pipe.remove(state, layerID, pipeID).updatedState;
      // if (!GeometryUtils.samePoints({ newVertex0X, newVertex0Y }, { newVertex1X, newVertex1Y })) {
      //   let ret = Pipe.createAvoidingIntersections(
      //     state,
      //     layerID,
      //     pipe.type,
      //     newVertex0X,
      //     newVertex0Y,
      //     newVertex1X,
      //     newVertex1Y,
      //     pipe.properties,
      //     holesWithOffsetPosition
      //   );

      //   state = ret.updatedState;

      //   //re-add to old pipes's groups if present
      //   ret.pipes.forEach(addedPipe => {
      //     pipeGroups.forEach(oldPipeGroup => {
      //       state = Group.addElement(state, oldPipeGroup.id, layerID, 'pipes', addedPipe.id).updatedState;
      //     });
      //   });
      // }

      //#endregion

      var updatedPipe = layer.pipes.get(pipeID);
      if (updatedPipe) {
        updatedPipe.vertices.forEach(function (vID) {
          var vertexPipes = state.getIn(['scene', 'layers', layerID, 'vertices', vID, 'pipes']);
          if (vertexPipes) {
            vertexPipes.forEach(function (pID) {
              state = Pipe.setPipeLengthMisc(state, layerID, pID).updatedState;
            });
          }
        });
      }

      state = Layer.removeZeroLengthPipes(state, layerID).updatedState;
      //state = this.detectAndInsertPipeFitting(state, layerID, pipeID);

      state = state.merge({
        mode: MODE_IDLE,
        draggingSupport: null,
        activeSnapElement: null,
        snapElements: new List()
      });

      return { updatedState: state };
    }
  }, {
    key: 'setPipeLengthMisc',
    value: function setPipeLengthMisc(state, layerID, pipeID) {

      var layer = state.scene.layers.get(layerID);
      var pipe = layer.pipes.get(pipeID);
      if (pipe) {
        var vertex0 = layer.vertices.get(pipe.vertices.get(0));
        var vertex1 = layer.vertices.get(pipe.vertices.get(1));

        var x1 = vertex0.x,
            y1 = vertex0.y;
        var x2 = vertex1.x,
            y2 = vertex1.y;


        var length = GeometryUtils.pointsDistance(x1, y1, x2, y2);

        state = state.setIn(['scene', 'layers', layerID, 'pipes', pipeID, 'misc'], new Map({ '_pipeLength': parseFloat(length.toFixed(2)), '_unitLength': state.scene.unit }));
      }

      return { updatedState: state };
    }
  }, {
    key: 'setProperties',
    value: function setProperties(state, layerID, pipeID, properties) {
      state = state.mergeIn(['scene', 'layers', layerID, 'pipes', pipeID, 'properties'], properties);

      return { updatedState: state };
    }
  }, {
    key: 'setJsProperties',
    value: function setJsProperties(state, layerID, pipeID, properties) {
      return this.setProperties(state, layerID, pipeID, fromJS(properties));
    }
  }, {
    key: 'updateProperties',
    value: function updateProperties(state, layerID, pipeID, properties) {
      properties.forEach(function (v, k) {
        if (state.hasIn(['scene', 'layers', layerID, 'pipes', pipeID, 'properties', k])) state = state.mergeIn(['scene', 'layers', layerID, 'pipes', pipeID, 'properties', k], v);
      });

      return { updatedState: state };
    }
  }, {
    key: 'updateJsProperties',
    value: function updateJsProperties(state, layerID, pipeID, properties) {
      return this.updateProperties(state, layerID, pipeID, fromJS(properties));
    }
  }, {
    key: 'setAttributes',
    value: function setAttributes(state, layerID, pipeID, pipeAttributes) {

      var lAttr = pipeAttributes.toJS();
      var vertexOne = lAttr.vertexOne,
          vertexTwo = lAttr.vertexTwo,
          pipeLength = lAttr.pipeLength;


      delete lAttr['vertexOne'];
      delete lAttr['vertexTwo'];
      delete lAttr['pipeLength'];

      var floorID = lAttr['floorID'];
      var pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);
      pipe.holes.forEach(function (h) {
        state = state.setIn(['scene', 'layers', layerID, 'holes', h, 'floorID'], floorID);
      });

      state = state.mergeIn(['scene', 'layers', layerID, 'pipes', pipeID], fromJS(lAttr)).mergeIn(['scene', 'layers', layerID, 'vertices', vertexOne.id], { x: vertexOne.x, y: vertexOne.y }).mergeIn(['scene', 'layers', layerID, 'vertices', vertexTwo.id], { x: vertexTwo.x, y: vertexTwo.y }).mergeIn(['scene', 'layers', layerID, 'pipes', pipeID, 'misc'], new Map({ '_unitLength': pipeLength._unit })).mergeIn(['scene', 'layers', layerID, 'pipes', pipeID, 'misc'], new Map({ '_pipeLength': pipeLength._length }));

      state = Layer.mergeEqualsVertices(state, layerID, vertexOne.id).updatedState;

      if (vertexOne.x != vertexTwo.x && vertexOne.y != vertexTwo.y) {
        state = Layer.mergeEqualsVertices(state, layerID, vertexTwo.id).updatedState;
      }

      return { updatedState: state };
    }
  }, {
    key: 'setVerticesCoords',
    value: function setVerticesCoords(state, layerID, pipeID, x1, y1, x2, y2) {
      var pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);
      state = Vertex.setAttributes(state, layerID, pipe.vertices.get(0), new Map({ x: x1, y: y1 })).updatedState;
      state = Vertex.setAttributes(state, layerID, pipe.vertices.get(1), new Map({ x: x2, y: y2 })).updatedState;

      return { updatedState: state };
    }

    //#region Pipe splitting and automatic hole insertion methods if needed. Not working proporly on some cases

    // static isElbowPosition(layer, allPipes, vertex0, vertex1) {

    //   let pipe, vertex;

    //   if (allPipes && allPipes.size > 0) {
    //     try {
    //       allPipes.forEach(p => {
    //         let pV0 = layer.vertices.get(p.vertices.get(0));
    //         let pV1 = layer.vertices.get(p.vertices.get(1));

    //         if (GeometryUtils.samePoints(vertex0, pV0) || GeometryUtils.samePoints(vertex0, pV1)) {
    //           pipe = p;
    //           vertex = vertex0;
    //           throw BreakException;
    //         }

    //         if (GeometryUtils.samePoints(vertex1, pV0) || GeometryUtils.samePoints(vertex1, pV1)) {
    //           pipe = p;
    //           vertex = vertex1;
    //           throw BreakException;
    //         }
    //       })
    //     }
    //     catch (e) {
    //       // if (e !== BreakException)
    //       //   throw e;
    //       // else
    //       //   return { otherPipe: piep, pipeVertex: vertex };
    //       //let debug = 1;
    //     }
    //   }

    //   return { otherPipe: pipe, pipeVertex: vertex };
    // }

    // //TODO: refactor all this
    // static detectAndInsertFitting(state, layerID, pipeID) {

    //   let layer = state.scene.layers.get(layerID);
    //   let pipe = layer.pipes.get(pipeID);
    //   let vertex0 = layer.vertices.get(pipe.vertices.get(0));
    //   let vertex1 = layer.vertices.get(pipe.vertices.get(1));

    //   let otherPipes = state.getIn(['scene', 'layers', layerID, 'pipes']).filter(p => p.id !== pipeID);
    //   if (!otherPipes) {
    //     return { updatedState: state };
    //   }
    //   let { otherPipe: otherPipe, pipeInsertVertex } = this.isElbowPosition(layer, otherPipes, vertex0, vertex1);

    //   return { updatedState: state };
    // }

    // static insertPipeFittingOnAngle(state, layerID, pipes, pipesVertexAngles, fittingVertexID) {

    //   if (pipes.length === 2) { // Case with two pipes, only right anlge allowed. Find best place to insert elbow.
    //     state = this.insertElbowFitting(state, layerID, pipes, fittingVertexID);
    //     return state;
    //   }

    //   //TODO: Ask about the case when connecting 2 pipes with third pipe - all horizontal or all verticle. It is doable. 
    //   //TODO: Should we niples or couplings when only verticle/horizontal connection?
    //   if (pipes.length === 3) { // Case 3 pipes. Only 

    //     if (pipesVertexAngles.every(a => a === -0 || a === 0)) {
    //       //Connection of two horizontal pipes with third horizontal pipe
    //       return state;
    //     }

    //     if (pipesVertexAngles.every(a => a === -90 || a === 90)) {
    //       //Connection of two verticle pipes with third verticle pipe
    //       return state;
    //     }

    //     if (pipesVertexAngles.contains(180) || pipesVertexAngles.contains(-180)) {
    //       //state = this.insertTripleFittingOnHorizontalPipe(state, layerID, pipes); // Splitting of horizontal
    //       return state;
    //     }

    //     //state = this.insertTripleFittingOnVerticlePipe(state, layerID, pipes); // Splitting of verticle
    //     return state;
    //   }
    // }

    // //TODO: refactor old and new logic for fitting insertion
    // static insertElbowFitting(state, layerID, pipes, vertexID) {

    //   //let vertexID = this.getPipesCommonVertex(pipes);
    //   let vertex = state.getIn(['scene', 'layers', layerID, 'vertices', vertexID]);

    //   let pipe0 = pipes[0];
    //   let pipe1 = pipes[1];
    //   let p0V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(0)]);
    //   let p0V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(1)]);
    //   let cAngle0 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p0V0.x, p0V0.y, p0V1.x, p0V1.y);

    //   let veticlePipe;
    //   let horizontalPipe;
    //   if (cAngle0 === 90 || cAngle0 === -90) {
    //     veticlePipe = pipe0;
    //     horizontalPipe = pipe1;
    //   } else {
    //     veticlePipe = pipe1;
    //     horizontalPipe = pipe0;
    //   }

    //   let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(0)]);
    //   let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(1)]);
    //   let h0 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(0)]);
    //   let h1 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(1)]);

    //   let configVertexV = GeometryUtils.samePoints(v0, vertex) ? v1 : v0;
    //   let configVertexH = GeometryUtils.samePoints(h0, vertex) ? h1 : h0;

    //   let holeProps;
    //   if (vertex.x > configVertexH.x && vertex.y < configVertexV.y) { // Second quadrant. No flip needed.
    //   }

    //   if (vertex.x < configVertexH.x && vertex.y < configVertexV.y) {  // First quadrant. Flip verticle.
    //     let properties = {
    //       flip_vertical: { label: 'vertical flip', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     }
    //     holeProps = fromJS(properties);
    //   }

    //   if (vertex.x > configVertexH.x && vertex.y > configVertexV.y) {  // Third quadrant. Flip horizontal.       
    //     let properties = {
    //       flip_horizzontal: { label: 'flip orizzontale', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     }
    //     holeProps = fromJS(properties);
    //   }

    //   if (vertex.x < configVertexH.x && vertex.y > configVertexV.y) {  // Fourth quadrant. Both flips.     
    //     let properties = {
    //       flip_horizzontal: { label: 'flip orizzontale', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } },
    //       flip_vertical: { label: 'vertical flip', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     }
    //     holeProps = fromJS(properties);
    //   }

    //   let holeType = '[pipe]elbow';
    //   let holeOffset = GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, vertex.x, vertex.y, holeProps);
    //   holeOffset = holeOffset > 0.9 ? 1 - 0.003 : 0 + 0.003;

    //   state = Hole.create(state, layerID, holeType, veticlePipe.id, holeOffset, holeProps).updatedState;


    //   let debug = 1;
    //   return state;
    // }

    // static createAvoidingIntersections(state, layerID, type, x0, y0, x1, y1, oldProperties, oldHoles) {

    //   let points = [{ x: x0, y: y0 }, { x: x1, y: y1 }];
    //   let newPipes = [];

    //   state = state.getIn(['scene', 'layers', layerID, 'pipes']).reduce((reducedState, pipe) => {
    //     let [v0, v1] = pipe.vertices.map(vertexID => reducedState.getIn(['scene', 'layers', layerID, 'vertices']).get(vertexID)).toArray();

    //     let hasCommonEndpoint = (
    //       GeometryUtils.samePoints(v0, points[0]) ||
    //       GeometryUtils.samePoints(v0, points[1]) ||
    //       GeometryUtils.samePoints(v1, points[0]) ||
    //       GeometryUtils.samePoints(v1, points[1])
    //     );

    //     let intersection = GeometryUtils.twoLineSegmentsIntersection(points[0], points[1], v0, v1);

    //     if (intersection.type === 'colinear') {
    //       if (!oldHoles) { oldHoles = []; }

    //       let orderedVertices = GeometryUtils.orderVertices(points);

    //       reducedState.getIn(['scene', 'layers', layerID, 'pipes', pipe.id, 'holes']).forEach(holeID => {
    //         let hole = reducedState.getIn(['scene', 'layers', layerID, 'holes', holeID]);
    //         let oldLineLength = GeometryUtils.pointsDistance(v0.x, v0.y, v1.x, v1.y);
    //         let offset = GeometryUtils.samePoints(orderedVertices[1], pipe.vertices.get(1)) ? (1 - hole.offset) : hole.offset;
    //         let offsetPosition = GeometryUtils.extendLine(v0.x, v0.y, v1.x, v1.y, oldLineLength * offset);

    //         oldHoles.push({ hole, offsetPosition });
    //       });

    //       reducedState = this.remove(reducedState, layerID, pipe.id).updatedState;

    //       points.push(v0, v1);
    //     }

    //     if (intersection.type === 'intersecting' && (!hasCommonEndpoint)) {
    //       let result = this.split(reducedState, layerID, pipe.id, intersection.point.x, intersection.point.y);
    //       reducedState = result.updatedState;

    //       if (result.pipes && result.pipes.size) {
    //         result.pipes.forEach(p => {
    //           newPipes.push(p);
    //         })
    //       }
    //       points.push(intersection.point);
    //     }

    //     return reducedState;

    //   }, state);

    //   let { updatedState, pipes } = Pipe.addFromPoints(state, layerID, type, points, oldProperties, oldHoles);
    //   pipes.forEach(p => {
    //     updatedState = Pipe.setPipeLengthMisc(updatedState, layerID, p.id).updatedState;
    //     newPipes.push(p);
    //   });

    //   updatedState = this.setFittingsOnPipeAngle(updatedState, layerID, newPipes);

    //   return { updatedState, pipes };
    // }

    // static setFittingsOnPipeAngle(state, layerID, pipes) {
    //   if (!pipes)
    //     return state;

    //   if (pipes && pipes.length >= 4) // More than 3 connections = return. Case for auto insertion not allowed
    //     return state;

    //   if (pipes && pipes.length === 2) { // Two pipes, case when one connects to two other. return for now. Ask what to do?
    //     return state;
    //   }

    //   if (pipes && pipes.length === 1) { // One pipe, but may have connection with other. Check pipe vertecies.

    //     let pipe = pipes[0];
    //     let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe.vertices.get(0)]);
    //     let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe.vertices.get(1)]);

    //     let otherPipeID;
    //     if (v0.pipes && v0.pipes.size > 1) {
    //       otherPipeID = v0.pipes.filter(pID => pID !== pipe.id).first();
    //     } else if (v1.pipes && v1.pipes.size > 1) {
    //       otherPipeID = v1.pipes.filter(pID => pID !== pipe.id).first();
    //     } else {
    //       return state;
    //     }

    //     if (otherPipeID) {
    //       pipes.push(state.getIn(['scene', 'layers', layerID, 'pipes', otherPipeID]));
    //     }
    //   }

    //   let cAngles = [];
    //   pipes.forEach(p => {
    //     let pV0 = state.getIn(['scene', 'layers', layerID, 'vertices', p.vertices.get(0)]);
    //     let pV1 = state.getIn(['scene', 'layers', layerID, 'vertices', p.vertices.get(1)]);

    //     let cAngle = GeometryUtils.angleBetweenTwoPointsAndOrigin(pV0.x, pV0.y, pV1.x, pV1.y);
    //     cAngles.push(cAngle);
    //   });

    //   console.log(cAngles);

    //   // If any angle of connections not of allowed degrees = return
    //   let pipesVertexAngles = new List(cAngles);
    //   let allowedAngles = new List([-0, 0, -90, 90, -180, 180]);
    //   let isAllowed = true;
    //   pipesVertexAngles.forEach(a => {
    //     if (!allowedAngles.contains(a)) {
    //       isAllowed = false;
    //     }
    //   });

    //   if (isAllowed) {
    //     state = this.insertPipeFittingOnAngle(state, layerID, pipes, pipesVertexAngles);
    //     return state;
    //   }

    //   return state;
    // }

    // static insertPipeFittingOnAngle(state, layerID, pipes, pipesVertexAngles) {

    //   if (pipes.length === 2) { // Case with two pipes, only right anlge allowed. Find best place to insert elbow.
    //     state = this.insertElbowFitting(state, layerID, pipes);
    //     return state;
    //   }

    //   //TODO: Ask about the case when connecting 2 pipes with third pipe - all horizontal or all verticle. It is doable. 
    //   //TODO: Should we niples or couplings when only verticle/horizontal connection?
    //   if (pipes.length === 3) { // Case 3 pipes. Only 

    //     if (pipesVertexAngles.every(a => a === -0 || a === 0)) {
    //       //Connection of two horizontal pipes with third horizontal pipe
    //       return state;
    //     }

    //     if (pipesVertexAngles.every(a => a === -90 || a === 90)) {
    //       //Connection of two verticle pipes with third verticle pipe
    //       return state;
    //     }

    //     if (pipesVertexAngles.contains(180) || pipesVertexAngles.contains(-180)) {
    //       state = this.insertTripleFittingOnHorizontalPipe(state, layerID, pipes); // Splitting of horizontal
    //       return state;
    //     }

    //     //state = this.insertTripleFittingOnVerticlePipe(state, layerID, pipes); // Splitting of verticle
    //     return state;
    //   }

    //   return state;
    // }

    // static insertTripleFittingOnVerticlePipe(state, layerID, pipes) {

    //   let vertexID = this.getPipesCommonVertex(pipes);
    //   let vertex = state.getIn(['scene', 'layers', layerID, 'vertices', vertexID]);

    //   let pipe0 = pipes[0];
    //   let p0V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(0)]);
    //   let p0V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(1)]);
    //   let pipe1 = pipes[1];
    //   let p1V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe1.vertices.get(0)]);
    //   let p1V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe1.vertices.get(1)]);
    //   let pipe2 = pipes[2];
    //   let p2V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe2.vertices.get(0)]);
    //   let p2V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe2.vertices.get(1)]);

    //   let cAngle0 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p0V0.x, p0V0.y, p0V1.x, p0V1.y);
    //   let cAngle1 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p1V0.x, p1V0.y, p1V1.x, p1V1.y);
    //   let cAngle2 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p2V0.x, p2V0.y, p2V1.x, p2V1.y);

    //   let veticlePipe;
    //   let horizontalPipe;
    //   if (cAngle0 === 0 || cAngle0 === -0) {
    //     horizontalPipe = pipe0;
    //     veticlePipe = pipe1;
    //   } else if (cAngle1 === 0 || cAngle1 === -0) {
    //     horizontalPipe = pipe1;
    //     veticlePipe = pipe0;
    //   } else {
    //     horizontalPipe = pipe2;
    //     veticlePipe = pipe0;
    //   }

    //   let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(0)]);
    //   let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(1)]);
    //   let h0 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(0)]);
    //   let h1 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(1)]);

    //   let configVertexH = GeometryUtils.samePoints(h0, vertex) ? h1 : h0;

    //   let holeProps;
    //   if (vertex.x > configVertexH.x) { // Horizontal on left side of verticle. No flip needed.
    //   }

    //   if (vertex.x < configVertexH.x) { // Horizontal on right side of verticle. Flip triple.
    //     let properties = {
    //       flip_orizzontal: { label: 'flip orizzontale', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     };
    //     holeProps = fromJS(properties);
    //   }

    //   let holeType = '[pipe]triple';
    //   let holeOffset = GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, vertex.x, vertex.y);
    //   holeOffset = holeOffset > 0.9 ? 1 - 0.003 : 0 + 0.003;

    //   state = Hole.create(state, layerID, holeType, veticlePipe.id, holeOffset, holeProps).updatedState;

    //   return state;
    // }

    // static insertTripleFittingOnHorizontalPipe(state, layerID, pipes) {

    //   let vertexID = this.getPipesCommonVertex(pipes);
    //   let vertex = state.getIn(['scene', 'layers', layerID, 'vertices', vertexID]);

    //   let pipe0 = pipes[0];
    //   let p0V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(0)]);
    //   let p0V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(1)]);
    //   let pipe1 = pipes[1];
    //   let p1V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe1.vertices.get(0)]);
    //   let p1V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe1.vertices.get(1)]);
    //   let pipe2 = pipes[2];
    //   let p2V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe2.vertices.get(0)]);
    //   let p2V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe2.vertices.get(1)]);

    //   let cAngle0 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p0V0.x, p0V0.y, p0V1.x, p0V1.y);
    //   let cAngle1 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p1V0.x, p1V0.y, p1V1.x, p1V1.y);
    //   let cAngle2 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p2V0.x, p2V0.y, p2V1.x, p2V1.y);

    //   let veticlePipe;
    //   let horizontalPipe;
    //   if (cAngle0 === 90 || cAngle0 === -90) {
    //     veticlePipe = pipe0;
    //     horizontalPipe = pipe1;
    //   } else if (cAngle1 === 90 || cAngle1 === -90) {
    //     veticlePipe = pipe1;
    //     horizontalPipe = pipe0;
    //   } else {
    //     veticlePipe = pipe2;
    //     horizontalPipe = pipe0;
    //   }

    //   let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(0)]);
    //   let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(1)]);
    //   let h0 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(0)]);
    //   let h1 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(1)]);

    //   let configVertexV = GeometryUtils.samePoints(v0, vertex) ? v1 : v0;
    //   let holeProps;

    //   if (vertex.y < configVertexV.y) { // Verticle above horizontal. No flip needed.
    //   }

    //   if (vertex.y > configVertexV.y) { // Verticle bellow horizontal. Flip triple.
    //     let properties = {
    //       flip_orizzontal: { label: 'flip orizzontale', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     };
    //     holeProps = fromJS(properties);
    //   }

    //   let holeType = '[pipe]triple';
    //   let holeOffset = GeometryUtils.pointPositionOnLineSegment(h0.x, h0.y, h1.x, h1.y, vertex.x, vertex.y);
    //   holeOffset = holeOffset > 0.9 ? 1 - 0.003 : 0 + 0.003;

    //   state = Hole.create(state, layerID, holeType, horizontalPipe.id, holeOffset, holeProps).updatedState;

    //   return state;
    // }

    // static insertElbowFitting(state, layerID, pipes) {

    //   let vertexID = this.getPipesCommonVertex(pipes);
    //   let vertex = state.getIn(['scene', 'layers', layerID, 'vertices', vertexID]);

    //   let pipe0 = pipes[0];
    //   let pipe1 = pipes[1];
    //   let p0V0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(0)]);
    //   let p0V1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(1)]);
    //   let cAngle0 = GeometryUtils.angleBetweenTwoPointsAndOrigin(p0V0.x, p0V0.y, p0V1.x, p0V1.y);

    //   let veticlePipe;
    //   let horizontalPipe;
    //   if (cAngle0 === 90 || cAngle0 === -90) {
    //     veticlePipe = pipe0;
    //     horizontalPipe = pipe1;
    //   } else {
    //     veticlePipe = pipe1;
    //     horizontalPipe = pipe0;
    //   }

    //   let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(0)]);
    //   let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', veticlePipe.vertices.get(1)]);
    //   let h0 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(0)]);
    //   let h1 = state.getIn(['scene', 'layers', layerID, 'vertices', horizontalPipe.vertices.get(1)]);

    //   let configVertexV = GeometryUtils.samePoints(v0, vertex) ? v1 : v0;
    //   let configVertexH = GeometryUtils.samePoints(h0, vertex) ? h1 : h0;

    //   let holeProps;
    //   if (vertex.x > configVertexH.x && vertex.y < configVertexV.y) { // Second quadrant. No flip needed.
    //   }

    //   if (vertex.x < configVertexH.x && vertex.y < configVertexV.y) {  // First quadrant. Flip verticle.
    //     let properties = {
    //       flip_vertical: { label: 'vertical flip', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     }
    //     holeProps = fromJS(properties);
    //   }

    //   if (vertex.x > configVertexH.x && vertex.y > configVertexV.y) {  // Third quadrant. Flip horizontal.       
    //     let properties = {
    //       flip_horizzontal: { label: 'flip orizzontale', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     }
    //     holeProps = fromJS(properties);
    //   }

    //   if (vertex.x < configVertexH.x && vertex.y > configVertexV.y) {  // Fourth quadrant. Both flips.     
    //     let properties = {
    //       flip_horizzontal: { label: 'flip orizzontale', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } },
    //       flip_vertical: { label: 'vertical flip', type: 'checkbox', defaultValue: true, values: { 'none': false, 'yes': true } }
    //     }
    //     holeProps = fromJS(properties);
    //   }

    //   let holeType = '[pipe]elbow';
    //   let holeOffset = GeometryUtils.pointPositionOnLineSegment(v0.x, v0.y, v1.x, v1.y, vertex.x, vertex.y, holeProps);
    //   holeOffset = holeOffset > 0.9 ? 1 - 0.003 : 0 + 0.003;

    //   state = Hole.create(state, layerID, holeType, veticlePipe.id, holeOffset, holeProps).updatedState;

    //   return state;
    // }

    // static getPipesCommonVertex(pipes) {
    //   let pipesVertices = [];
    //   //let commonVertex = '';

    //   pipes.forEach(p => {
    //     p.vertices.forEach(v => {
    //       pipesVertices.push(v);
    //     })
    //   })

    //   var uniq = pipesVertices
    //     .map((name) => {
    //       return {
    //         count: 1,
    //         name: name
    //       }
    //     })
    //     .reduce((a, b) => {
    //       a[b.name] = (a[b.name] || 0) + b.count
    //       return a
    //     }, {})

    //   var duplicates = Object.keys(uniq).filter((a) => uniq[a] > 1);

    //   return duplicates[0];
    // }

    // static split(state, layerID, pipeID, x, y) {
    //   let pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);
    //   let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe.vertices.get(0)]);
    //   let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe.vertices.get(1)]);
    //   let { x: x0, y: y0 } = v0;
    //   let { x: x1, y: y1 } = v1;

    //   let { updatedState: stateL1, pipe: pipe0 } = Pipe.create(state, layerID, pipe.type, x0, y0, x, y, pipe.get('properties'));
    //   stateL1 = Pipe.setPipeLengthMisc(stateL1, layerID, pipe0.id).updatedState;

    //   let { updatedState: stateL2, pipe: pipe1 } = Pipe.create(stateL1, layerID, pipe.type, x1, y1, x, y, pipe.get('properties'));
    //   stateL2 = Pipe.setPipeLengthMisc(stateL2, layerID, pipe1.id).updatedState;
    //   state = stateL2;

    //   let splitPointOffset = GeometryUtils.pointPositionOnLineSegment(x0, y0, x1, y1, x, y);
    //   let minVertex = GeometryUtils.minVertex(v0, v1);

    //   pipe.holes.forEach(holeID => {
    //     let hole = state.getIn(['scene', 'layers', layerID, 'holes', holeID]);

    //     let holeOffset = hole.offset;
    //     if (minVertex.x === x1 && minVertex.y === y1) {
    //       splitPointOffset = 1 - splitPointOffset;
    //       holeOffset = 1 - hole.offset;
    //     }

    //     if (holeOffset < splitPointOffset) {
    //       let offset = holeOffset / splitPointOffset;
    //       if (minVertex.x === x1 && minVertex.y === y1) {
    //         offset = 1 - offset;
    //       }
    //       state = Hole.create(state, layerID, hole.type, pipe0.id, offset, hole.properties).updatedState;
    //     } else {
    //       let offset = (holeOffset - splitPointOffset) / (1 - splitPointOffset);
    //       if (minVertex.x === x1 && minVertex.y === y1) {
    //         offset = 1 - offset;
    //       }
    //       state = Hole.create(state, layerID, hole.type, pipe1.id, offset, hole.properties).updatedState;
    //     }
    //   });

    //   //add splitted pipes to the original pipes's group
    //   let pipeGroups = state
    //     .getIn(['scene', 'groups'])
    //     .filter(group => {
    //       const pipes = group.getIn(['elements', layerID, 'pipes']);
    //       return pipes && pipes.contains(pipeID);
    //     });

    //   pipeGroups.forEach(group => {
    //     state = Group.addElement(state, group.id, layerID, 'pipes', pipe0.id).updatedState;
    //     state = Group.addElement(state, group.id, layerID, 'pipes', pipe1.id).updatedState;
    //   });

    //   state = Pipe.remove(state, layerID, pipeID).updatedState;

    //   return { updatedState: state, pipes: new List([pipe0, pipe1]) };
    // }

    // static addFromPoints(state, layerID, type, points, properties, holes) {
    //   points = new List(points)
    //     .sort(({ x: x1, y: y1 }, { x: x2, y: y2 }) => x1 === x2 ? y1 - y2 : x1 - x2);

    //   let pointsPair = points.zip(points.skip(1))
    //     .filterNot(([{ x: x1, y: y1 }, { x: x2, y: y2 }]) => x1 === x2 && y1 === y2);

    //   let pipes = [];

    //   pointsPair.forEach(([{ x: x1, y: y1 }, { x: x2, y: y2 }]) => {
    //     let { updatedState: stateL, pipe } = this.create(state, layerID, type, x1, y1, x2, y2, properties);
    //     state = stateL;

    //     if (holes) {
    //       holes.forEach(holeWithOffsetPoint => {
    //         let { x: xp, y: yp } = holeWithOffsetPoint.offsetPosition;

    //         if (GeometryUtils.isPointOnLineSegment(x1, y1, x2, y2, xp, yp)) {

    //           let newOffset = GeometryUtils.pointPositionOnLineSegment(x1, y1, x2, y2, xp, yp);
    //           //let newOffset = holeWithOffsetPoint.hole.offset;

    //           if (newOffset >= 0 && newOffset <= 1) {
    //             state = Hole.create(state, layerID, holeWithOffsetPoint.hole.type, pipe.id, newOffset, holeWithOffsetPoint.hole.properties).updatedState;
    //           }
    //         }
    //       });
    //     }

    //     pipes.push(pipe);
    //   });

    //   return { updatedState: state, pipes: new List(pipes) };
    // }

    // static compareVerticesReturnIsReversed(state, layerID, pipe0, pipe1) {
    //   let v00 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(0)]);
    //   let v01 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(1)]);
    //   let comparePipe0 = GeometryUtils.compareVertices(v00, v01);

    //   let v10 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe1.vertices.get(0)]);
    //   let v11 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe1.vertices.get(1)]);
    //   let comparePipe1 = GeometryUtils.compareVertices(v10, v11);

    //   if (comparePipe0 < 0)
    //     return false;
    //   else {
    //     return true;
    //   }
    // }

    // static splitPipeFromHole(state, layerID, pipeID, x, y) {
    //   let pipe = state.getIn(['scene', 'layers', layerID, 'pipes', pipeID]);
    //   let v0 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe.vertices.get(0)]);
    //   let v1 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe.vertices.get(1)]);
    //   let { x: x0, y: y0 } = v0;
    //   let { x: x1, y: y1 } = v1;

    //   let { updatedState: stateL1, pipe: pipe0 } = Pipe.create(state, layerID, pipe.type, x0, y0, x, y, pipe.get('properties'));
    //   stateL1 = Pipe.setPipeLengthMisc(stateL1, layerID, pipe0.id).updatedState;

    //   let { updatedState: stateL2, pipe: pipe1 } = Pipe.create(stateL1, layerID, pipe.type, x1, y1, x, y, pipe.get('properties'));
    //   stateL2 = Pipe.setPipeLengthMisc(stateL2, layerID, pipe1.id).updatedState;
    //   state = stateL2;

    //   // let splitPointOffset = GeometryUtils.pointPositionOnLineSegment(x0, y0, x1, y1, x, y);
    //   // let minVertex = GeometryUtils.minVertex(v0, v1);
    //   // console.log(`*** CURRENT SPLIT ***************`);
    //   // console.log(`SplitPointOffset: ${splitPointOffset}`);

    //   let v00 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(0)]);
    //   let v01 = state.getIn(['scene', 'layers', layerID, 'vertices', pipe0.vertices.get(1)]);

    //   if (v00.x.toFixed(2) === v01.x.toFixed(2)) { // Vertical pipe on 2d drawing
    //     //console.log(`*** VERTICAL LINE ********:`);
    //     if (pipe.holes.size === 1) {
    //       let hole = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(0)]);
    //       let offset = 1 - 0.003;
    //       state = Hole.create(state, layerID, hole.type, pipe0.id, offset, hole.properties).updatedState;
    //     }

    //     if (pipe.holes.size === 2) {
    //       let holeOne = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(0)]);
    //       let holeTwo = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(1)]);

    //       let offset1 = 0;
    //       let offset2 = 0;
    //       if (holeOne.offset > holeTwo.offset) {
    //         offset1 = 0 + 0.003;
    //         state = Hole.create(state, layerID, holeOne.type, pipe1.id, offset1, holeOne.properties).updatedState;

    //         offset2 = 1 - 0.003;
    //         state = Hole.create(state, layerID, holeTwo.type, pipe1.id, offset2, holeTwo.properties).updatedState;
    //       } else {
    //         offset1 = 0 + 0.003;
    //         state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //         offset2 = 1 - 0.003;
    //         state = Hole.create(state, layerID, holeTwo.type, pipe0.id, offset2, holeTwo.properties).updatedState;
    //       }
    //     }

    //     if (pipe.holes.size === 3) {
    //       let holeOne = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(0)]);
    //       let holeTwo = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(1)]);
    //       let holeThree = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(2)]);

    //       // console.log(`holeOne: ${holeOne}`);
    //       // console.log(`holeTwo: ${holeTwo}`);
    //       // console.log(`holeThree: ${holeThree}`);

    //       let offset1 = 0;
    //       let offset2 = 0;
    //       let offset3 = 0;

    //       if (holeOne.offset > holeTwo.offset) {
    //         offset1 = 0 + 0.003;
    //         state = Hole.create(state, layerID, holeOne.type, pipe1.id, offset1, holeOne.properties).updatedState;

    //         offset2 = 0 + 0.003;
    //         state = Hole.create(state, layerID, holeTwo.type, pipe0.id, offset2, holeTwo.properties).updatedState;

    //         offset3 = 1 - 0.003;
    //         state = Hole.create(state, layerID, holeThree.type, pipe0.id, offset3, holeThree.properties).updatedState;
    //       }
    //       else {
    //         offset1 = 0 + 0.003;
    //         state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //         offset2 = 0 + 0.003;
    //         state = Hole.create(state, layerID, holeTwo.type, pipe1.id, offset2, holeTwo.properties).updatedState;

    //         offset3 = 1 - 0.003;
    //         state = Hole.create(state, layerID, holeThree.type, pipe0.id, offset3, holeThree.properties).updatedState;
    //       }
    //     }
    //   } else { //Horizontal and other pipes
    //     if (pipe.holes.size === 1) {
    //       let hole = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(0)]);
    //       let offset = 0;

    //       let isReversedPipes = this.compareVerticesReturnIsReversed(state, layerID, pipe0, pipe1);
    //       if (isReversedPipes) {
    //         offset = 1 - 0.003;
    //         state = Hole.create(state, layerID, hole.type, pipe1.id, offset, hole.properties).updatedState;
    //       } else {
    //         offset = 1 - 0.003;
    //         state = Hole.create(state, layerID, hole.type, pipe0.id, offset, hole.properties).updatedState;
    //       }
    //     }

    //     let offset1 = 0;
    //     let offset2 = 0;

    //     if (pipe.holes.size === 2) {
    //       let holeOne = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(0)]);
    //       let holeTwo = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(1)]);

    //       let isReversedPipes = this.compareVerticesReturnIsReversed(state, layerID, pipe0, pipe1);
    //       if (isReversedPipes) {
    //         if (holeOne.offset < 0.1) {
    //           offset1 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //           offset2 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe0.id, offset2, holeTwo.properties).updatedState;

    //         } else {//(holeOne.offset > 0.9)
    //           offset1 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //           offset2 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe0.id, offset2, holeTwo.properties).updatedState;
    //         }
    //         // else {
    //         //   let debug = 1;
    //         //   console.log(`holeOne: ${holeOne}`);
    //         // }
    //       }
    //       else {
    //         if (holeOne.offset < 0.1) {
    //           offset1 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;
    //           offset2 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe0.id, offset2, holeTwo.properties).updatedState;

    //         } else { // if (holeOne.offset > 0.9) 
    //           offset1 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe1.id, offset1, holeOne.properties).updatedState;
    //           offset2 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe1.id, offset2, holeTwo.properties).updatedState;
    //         }
    //         // else {
    //         //   let debug = 1;
    //         //   console.log(`holeOne: ${holeOne}`);
    //         // }
    //       }
    //     }

    //     if (pipe.holes.size === 3) {
    //       let holeOne = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(0)]);
    //       let holeTwo = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(1)]);
    //       let holeThree = state.getIn(['scene', 'layers', layerID, 'holes', pipe.holes.get(2)]);

    //       // console.log(`holeOne: ${holeOne}`);
    //       // console.log(`holeTwo: ${holeTwo}`);
    //       // console.log(`holeThree: ${holeThree}`);

    //       let offset1 = 0;
    //       let offset2 = 0;
    //       let offset3 = 0;

    //       let isReversedPipes = this.compareVerticesReturnIsReversed(state, layerID, pipe0, pipe1);
    //       if (isReversedPipes) {
    //         if (holeOne.offset < 0.1) {
    //           offset1 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //           offset2 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe1.id, offset2, holeTwo.properties).updatedState;

    //           offset3 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeThree.type, pipe0.id, offset3, holeThree.properties).updatedState;

    //         } else {// if (holeOne.offset > 0.9) 
    //           offset1 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //           offset2 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe1.id, offset2, holeTwo.properties).updatedState;

    //           offset3 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeThree.type, pipe0.id, offset3, holeThree.properties).updatedState;
    //         }
    //         // else {
    //         //   let debug = 1;
    //         //   console.log(`holeOne: ${holeOne}`);
    //         // }
    //       }
    //       else {
    //         if (holeOne.offset < 0.1) {
    //           offset1 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe0.id, offset1, holeOne.properties).updatedState;

    //           offset2 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe1.id, offset2, holeTwo.properties).updatedState;

    //           offset3 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeThree.type, pipe0.id, offset3, holeThree.properties).updatedState;

    //         } else {// if (holeOne.offset > 0.9) 
    //           offset1 = 1 - 0.003;
    //           state = Hole.create(state, layerID, holeOne.type, pipe1.id, offset1, holeOne.properties).updatedState;

    //           offset2 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeTwo.type, pipe0.id, offset2, holeTwo.properties).updatedState;

    //           offset3 = 0 + 0.003;
    //           state = Hole.create(state, layerID, holeThree.type, pipe1.id, offset3, holeThree.properties).updatedState;
    //         }
    //         // else {
    //         //   let debug = 1;
    //         //   console.log(`holeOne: ${holeOne}`);
    //         // }
    //       }
    //     }
    //   }

    //   //add splitted pipes to the original pipes's group
    //   let pipeGroups = state
    //     .getIn(['scene', 'groups'])
    //     .filter(group => {
    //       const pipes = group.getIn(['elements', layerID, 'pipes']);
    //       return pipes && pipes.contains(pipeID);
    //     });

    //   pipeGroups.forEach(group => {
    //     state = Group.addElement(state, group.id, layerID, 'pipes', pipe0.id).updatedState;
    //     state = Group.addElement(state, group.id, layerID, 'pipes', pipe1.id).updatedState;
    //   });

    //   state = Pipe.remove(state, layerID, pipeID).updatedState;

    //   return { updatedState: state, pipes: new List([pipe0, pipe1]) };
    // }

    //#endregion 

  }]);

  return Pipe;
}();

export { Pipe as default };